import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/lifedatareplicator-general-types/lifedatareplicator/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
